export default __webpack_public_path__ + "static/roboto-v20-latin-ext-300-3703ee02e4653520abbf080f8ee475de.woff2";